export const environment = {
  production: true,
  apiUrl: "https://api.ek-mediencenter.de",
  matomo: {
    enabled: true,
    serverUrl: 'https://ekretail.matomo.cloud/',
    siteId: 5
  },
  sso: {
    enabled: true,
    tenant: "ekretailsso",
    clientId: "9e085030-1686-41be-8479-423ecb9c9792",
    redirectUri: "https://app.ek-mediencenter.de/sso",
  },
  launchpad: {
    enabled: false,
    url: "",
  },
};
